import React, { useState } from 'react';
import './Users.css';

function Users() {
  const [users, setUsers] = useState([
    {
      id: 1,
      name: 'John Smith',
      email: 'john.smith@company.com',
      role: 'Admin',
      status: 'Active',
      lastLogin: '2025-12-22',
      conversions: 15,
      analyses: 8
    },
    {
      id: 2,
      name: 'Sarah Johnson',
      email: 'sarah.johnson@company.com',
      role: 'Editor',
      status: 'Active',
      lastLogin: '2025-12-22',
      conversions: 23,
      analyses: 12
    },
    {
      id: 3,
      name: 'Michael Brown',
      email: 'michael.brown@company.com',
      role: 'Editor',
      status: 'Active',
      lastLogin: '2025-12-21',
      conversions: 8,
      analyses: 5
    },
    {
      id: 4,
      name: 'Emily Davis',
      email: 'emily.davis@company.com',
      role: 'Viewer',
      status: 'Active',
      lastLogin: '2025-12-20',
      conversions: 0,
      analyses: 3
    },
    {
      id: 5,
      name: 'David Wilson',
      email: 'david.wilson@company.com',
      role: 'Editor',
      status: 'Inactive',
      lastLogin: '2025-12-10',
      conversions: 12,
      analyses: 6
    }
  ]);

  const [showAddForm, setShowAddForm] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    role: 'Viewer',
    password: ''
  });

  const handleAddUser = (e) => {
    e.preventDefault();
    const user = {
      id: users.length + 1,
      name: newUser.name,
      email: newUser.email,
      role: newUser.role,
      status: 'Active',
      lastLogin: new Date().toISOString().split('T')[0],
      conversions: 0,
      analyses: 0
    };
    setUsers([...users, user]);
    setNewUser({ name: '', email: '', role: 'Viewer', password: '' });
    setShowAddForm(false);
  };

  const handleDeleteUser = (id) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      setUsers(users.filter(user => user.id !== id));
    }
  };

  const handleToggleStatus = (id) => {
    setUsers(users.map(user =>
      user.id === id
        ? { ...user, status: user.status === 'Active' ? 'Inactive' : 'Active' }
        : user
    ));
  };

  return (
    <div className="users-container">
      <div className="users-header">
        <div>
          <h1>Users</h1>
          <p>Manage user accounts and permissions</p>
        </div>
        <button
          className="primary-button"
          onClick={() => setShowAddForm(!showAddForm)}
        >
          {showAddForm ? 'Cancel' : '+ Add User'}
        </button>
      </div>

      {showAddForm && (
        <div className="add-user-form">
          <h2>New User</h2>
          <form onSubmit={handleAddUser}>
            <div className="form-row">
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  value={newUser.name}
                  onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                  placeholder="John Doe"
                  required
                />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  value={newUser.email}
                  onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                  placeholder="john.doe@company.com"
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Role</label>
                <select
                  value={newUser.role}
                  onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                  required
                >
                  <option value="Viewer">Viewer</option>
                  <option value="Editor">Editor</option>
                  <option value="Admin">Admin</option>
                </select>
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  value={newUser.password}
                  onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                  placeholder="Enter password"
                  required
                />
              </div>
            </div>
            <div className="role-info">
              <h4>Role Permissions:</h4>
              <ul>
                <li><strong>Viewer:</strong> Can view analyses and conversion results</li>
                <li><strong>Editor:</strong> Can create analyses and conversions</li>
                <li><strong>Admin:</strong> Full access including user and settings management</li>
              </ul>
            </div>
            <div className="form-actions">
              <button type="button" className="secondary-button" onClick={() => setShowAddForm(false)}>
                Cancel
              </button>
              <button type="submit" className="primary-button">
                Add User
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="users-stats">
        <div className="stat-box">
          <h3>{users.filter(u => u.status === 'Active').length}</h3>
          <p>Active Users</p>
        </div>
        <div className="stat-box">
          <h3>{users.filter(u => u.role === 'Admin').length}</h3>
          <p>Admins</p>
        </div>
        <div className="stat-box">
          <h3>{users.filter(u => u.role === 'Editor').length}</h3>
          <p>Editors</p>
        </div>
        <div className="stat-box">
          <h3>{users.filter(u => u.role === 'Viewer').length}</h3>
          <p>Viewers</p>
        </div>
      </div>

      <div className="users-table-section">
        <h2>User List</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Status</th>
                <th>Last Login</th>
                <th>Conversions</th>
                <th>Analyses</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>
                    <div className="user-info">
                      <div className="user-avatar">
                        {user.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <span>{user.name}</span>
                    </div>
                  </td>
                  <td>{user.email}</td>
                  <td>
                    <span className={`role-badge ${user.role.toLowerCase()}`}>
                      {user.role}
                    </span>
                  </td>
                  <td>
                    <span className={`status-badge ${user.status.toLowerCase()}`}>
                      {user.status}
                    </span>
                  </td>
                  <td>{user.lastLogin}</td>
                  <td>{user.conversions}</td>
                  <td>{user.analyses}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-icon edit"
                        onClick={() => alert('Edit functionality would be implemented here')}
                        title="Edit user"
                      >
                        ✎
                      </button>
                      <button
                        className="action-icon toggle"
                        onClick={() => handleToggleStatus(user.id)}
                        title={user.status === 'Active' ? 'Deactivate user' : 'Activate user'}
                      >
                        {user.status === 'Active' ? '⊗' : '○'}
                      </button>
                      <button
                        className="action-icon delete"
                        onClick={() => handleDeleteUser(user.id)}
                        title="Delete user"
                      >
                        ×
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Users;
